import { lazy } from 'react'
import type { RouteObject } from 'react-router'
const PageCommunication = lazy(() =>
  import('./PageCommunication').then((m) => ({ default: m.PageCommunication })),
)
const PageDesinscription = lazy(() =>
  import('./Preferences').then((m) => ({ default: m.PageDesinscription })),
)
export const routesCommunication: RouteObject[] = [{ index: true, element: <PageCommunication /> }]
export const routesPreferencePublique: RouteObject[] = [
  { index: true, element: <PageDesinscription /> },
]
